export enum EnterpriseTypesToCalcEnum {
    PERCENT = 'PERCENT',
    CURRENCY = 'CURRENCY',
}
